import styled from '@emotion/styled';

interface MatterportBlockBetaProps {
	url: string;
	index?: number;
}

const Wrapper = styled.section`
	padding: 2rem 1.5rem 3rem;
	background: white;
`;

const Title = styled.h2`
	text-transform: uppercase;
	font-size: 1.5rem;
	letter-spacing: 0.2em;
	text-align: center;
	margin-bottom: 1.5rem;
`;

const Frame = styled.iframe`
	width: 100%;
	aspect-ratio: 16 / 9;
	border: none;
`;

export default function MatterportBlockBeta({ url, index }: MatterportBlockBetaProps) {
	return (
		<Wrapper id={index == null ? '3d_tours' : undefined}>
			<Title>3D Tour</Title>
			<Frame src={url} allowFullScreen allow="xr-spatial-tracking" />
		</Wrapper>
	);
}
